import React from "react";
import icefLogo from "../assets/accreditations/icef.png";
import bbsnLogo from "../assets/accreditations/bbsn.png";
import englishUkLogo from "../assets/accreditations/english-uk.png";
import britishCouncilLogo from "../assets/accreditations/british-council.png";
import navitasLogo from "../assets/accreditations/navitas.png";
import studyTravelLogo from "../assets/accreditations/studytravel.png";
import { useLang } from "../i18n/LangContext";
import { accreditationsI18n } from "../i18n/accreditations_i18n";

const Accreditations = () => {
  const { lang } = useLang();
  const i18n = accreditationsI18n[lang] || accreditationsI18n.ru;
  const isRtl = lang === 'ar';

  const items = [
    { key: 'icef', src: icefLogo, alt: 'ICEF Trusted Agency 2026' },
    { key: 'bbsn', src: bbsnLogo, alt: 'BBSN Approved Agent' },
    { key: 'englishUk', src: englishUkLogo, alt: 'English UK Partner Agency' },
    { key: 'britishCouncil', src: britishCouncilLogo, alt: 'British Council Training Award' },
    { key: 'navitas', src: navitasLogo, alt: 'Heart of Navitas Champions' },
    { key: 'studyTravel', src: studyTravelLogo, alt: 'StudyTravel Reference Checked' }
  ];

  return (
    <section className="py-14 md:py-16 relative" style={{ background: '#FAF8F5' }} data-testid="accreditations-section" dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-9">
          <div className="text-[11px] font-bold tracking-[0.22em] uppercase" style={{ color: '#C9A96E' }}>{i18n.title}</div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6 md:gap-8 items-stretch justify-items-center">
          {items.map((a) => (
            <div
              key={a.key}
              className="flex flex-col items-center text-center group w-full"
              title={i18n.items[a.key]}
              data-testid={`accreditation-${a.key}`}
            >
              <div className="relative h-28 md:h-32 w-full flex items-center justify-center px-2">
                <img
                  src={a.src}
                  alt={a.alt}
                  className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-[1.06] group-hover:-translate-y-1"
                  draggable={false}
                />
              </div>
              <div className="mt-4 text-[10px] tracking-[0.15em] uppercase font-semibold leading-snug" style={{ color: '#1B2A4A' }}>{i18n.items[a.key]}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accreditations;
